export const colors = {
  primary: "#3F91DD",
  secondary: "#74C0FC",
  gray1: "#212529",
  gray2: "#868E96",
  gray3: "#ADB5BD",
  gray4: "#E9ECEF",
  gray5: "#F1F3F5",
  gray6: "#F8F9FA",
};
